/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Operation Portal APIs
 * OpenAPI spec version: 0.1
 */

export type CustomerSourceOfFunds =
  typeof CustomerSourceOfFunds[keyof typeof CustomerSourceOfFunds];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerSourceOfFunds = {
  BENEFITS: 'BENEFITS',
  COMPANY_PROFIT: 'COMPANY_PROFIT',
  DIVORCE: 'DIVORCE',
  FRIENDS_AND_FAMILY: 'FRIENDS_AND_FAMILY',
  GAMBLING: 'GAMBLING',
  GIFT: 'GIFT',
  INHERITANCE: 'INHERITANCE',
  INVESTMENTS: 'INVESTMENTS',
  LOANS: 'LOANS',
  PENSION: 'PENSION',
  PROPERTY: 'PROPERTY',
  REDUNDANCY: 'REDUNDANCY',
  SALARY_OR_WAGE: 'SALARY_OR_WAGE',
  SAVINGS: 'SAVINGS',
  INSURANCE: 'INSURANCE',
  OTHER: 'OTHER',
} as const;
